interface Column {
  header: string
  width?: string
}

interface MockTableProps {
  columns: Column[]
  rows: React.ReactNode[][]
  caption?: string
}

export function MockTable({ columns, rows, caption }: MockTableProps) {
  return (
    <div className="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-sm overflow-hidden select-none">
      {caption && (
        <div className="px-4 py-2 bg-gray-50 dark:bg-gray-750 border-b border-gray-200 dark:border-gray-700 text-xs text-gray-500 dark:text-gray-400 font-medium">
          {caption}
        </div>
      )}
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-gray-50 dark:bg-gray-750 border-b border-gray-200 dark:border-gray-700">
              {columns.map((col, i) => (
                <th
                  key={i}
                  className="px-3 py-2 text-left text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                  style={col.width ? { width: col.width } : undefined}
                >
                  {col.header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100 dark:divide-gray-700">
            {rows.map((row, ri) => (
              <tr key={ri} className="hover:bg-gray-50/50 dark:hover:bg-gray-700/30">
                {row.map((cell, ci) => (
                  <td
                    key={ci}
                    className="px-3 py-2 text-gray-700 dark:text-gray-300 whitespace-nowrap"
                  >
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export function MockAgGridHeader({ columns }: { columns: string[] }) {
  return (
    <div className="rounded-t-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 overflow-hidden select-none">
      <div className="flex bg-gray-50 dark:bg-gray-750 border-b border-gray-200 dark:border-gray-700">
        {columns.map((col, i) => (
          <div
            key={i}
            className="px-3 py-2 text-xs font-semibold text-gray-500 dark:text-gray-400 border-r border-gray-200 dark:border-gray-700 last:border-r-0 flex-1 min-w-0 truncate"
          >
            {col}
          </div>
        ))}
      </div>
      <div className="px-4 py-3 text-xs text-gray-400 dark:text-gray-500 italic">
        ← строки таблицы с данными →
      </div>
    </div>
  )
}
